import { render } from "./DataDialog.vue?vue&type=template&id=34643dbf"
import script from "./DataDialog.vue?vue&type=script&lang=js"
export * from "./DataDialog.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/other/workflow/components/lFComponents/DataDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34643dbf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34643dbf', __exports__)) {
    console.log('reload')
    api.reload('34643dbf', __exports__)
  }
  
  module.hot.accept("./DataDialog.vue?vue&type=template&id=34643dbf", () => {
    console.log('re-render')
    api.rerender('34643dbf', render)
  })

}


export default __exports__